var _rect, _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 736,
    viewBox: "0 0 1440 736",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9485_19556)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 736,
    fill: "#0A0C1F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9485_19556)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1166.75,
    cy: 557.788,
    rx: 247.746,
    ry: 175.212,
    fill: "url(#paint0_linear_9485_19556)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "color-dodge"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9485_19556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 894,
    y: 470,
    width: 659,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1552.04 472.706V470.979H894.952V472.706C894.952 477.751 894.952 480.273 896.366 482.2C897.609 483.895 899.593 485.273 902.033 486.137C904.807 487.118 908.439 487.118 915.702 487.118H1531.29C1538.55 487.118 1542.19 487.118 1544.96 486.137C1547.4 485.273 1549.38 483.895 1550.63 482.2C1552.04 480.273 1552.04 477.751 1552.04 472.706Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9485_19556)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9485_19556)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9485_19556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 948,
    y: 453,
    width: 551,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M948.845 470.979V459.451C948.845 455.95 951.684 453.111 955.185 453.111H1492.39C1495.89 453.111 1498.73 455.95 1498.73 459.451V470.979H1494.4H953.168H948.845Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9485_19556)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9485_19556)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_9485_19556)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_9485_19556)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9485_19556)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_9485_19556)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9485_19556",
    x: 667.8,
    y: 131.375,
    width: 997.894,
    height: 852.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125.6,
    result: "effect1_foregroundBlur_9485_19556"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9485_19556",
    x: 894.664,
    y: 466.368,
    width: 11.8161,
    height: 16.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.864592,
    result: "effect1_foregroundBlur_9485_19556"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9485_19556",
    x: 949.998,
    y: 454.392,
    width: 12.1297,
    height: 17.1641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.288197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0745098 0 0 0 0 0.0666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9485_19556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9485_19556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_9485_19556",
    x: 952.015,
    y: 454.552,
    width: 543.54,
    height: 16.4272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.288197,
    dy: -0.288197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9485_19556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.288197,
    dy: -0.288197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9485_19556",
    result: "effect2_innerShadow_9485_19556"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_9485_19556",
    x: 950.574,
    y: 93.729,
    width: 546.422,
    height: 377.538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.288197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9485_19556"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.288197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9485_19556",
    result: "effect2_innerShadow_9485_19556"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_9485_19556",
    x: 1319,
    y: 624,
    width: 100.561,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9485_19556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9485_19556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9485_19556",
    x1: 969.929,
    y1: 460.362,
    x2: 1370.82,
    y2: 461.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D09D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#A60287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9327FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9485_19556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 736,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9485_19556"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M961.526 110.157C961.526 106.337 964.622 103.24 968.442 103.24H1479.13C1482.95 103.24 1486.04 106.337 1486.04 110.157V444.177H961.526V110.157Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBg);
export default __webpack_public_path__ + "static/media/auth_bg.bcc244f86d47977bfe799dac6a09d955.svg";
export { ForwardRef as ReactComponent };